import { DocumentationWithExternalLink } from '../../../../Definitions/Definition/Drawer/Content/DocumentationWithExternalLink';
import { UiBlockType } from '../../../types';

export function GetNotableObjectDocumentation() {
  const documentationMarkdown = `
# Get Notable Object

This block searches Notable’s database for records.

If an identifier is supplied, returns a single record with that identifier from the database. If it doesn’t exist, the block will fail.

## When to use this block

Use this block when the flow needs additional context from a related record from Notable's database.

## How to use this block
Select the Notable object you want to fetch (see options below). Based on the object selected, the block will display the appropriate configuration fields.

### Supported objects

We support the following objects:

#### Reference Tables

Reference Tables are tabular datasets, configured [here](https://app.notablehealth.com/staff/app/#/agents/flows/referenceTables). These can be made specific to an organization or global for all of Notable.

To search for a reference table, select the table by name in the configuration dropdown.

#### Payment Table

Extract a Payment from Notable's database corresponding to the Start block entity. Currently only Patient and Encounter entities are supported.

#### Patient Order

Extract a Patient Order from Notable's database using an identifier.

#### Provider

Extract a Provider from Notable's database using an identifier.

#### External Document Packet

Extract an External Document Packet from Notable's database using an identifier.

#### Patient

Extract a Patient from Notable's database using any of the following lookup criteria:
 - The ehr Information Id (can be found on the encounter or other entities hydrated with Notable metadata)
 - The patient MRN (patient EHR ID)
 - At least 2 values from:
   - First Name
   - Last Name
   - Date of Birth
   - Phone Number _(matching against any known patient phone number in the Notable Patient record)_
 - Level of strictness for validating a match with a patient if found by MRN (First Name, Last Name, Date of Birth, and Phone Number)
   - Must match all of the provided demographic fields and will be the default selection
   - Must match at least two of the provided demographic fields
   - Must match at least three of the provided demographic fields

#### Template

Extract a Template Details from Notable's database using an identifier.

#### Patient Upload

Extract a Patient Upload from Notable's database, optionally including a document type. Currently only Patient and Encounter entities are supported.

#### Primary Care Provider

Extract all Primary Care Providers from Notable's database based on the flow's entity.

#### Insurance OCR Results

Extract Insurance OCR Results from Notable's database using a Patient Upload ID. This object returns the OCR (Optical Character Recognition) processing results from insurance card uploads, including extracted member information, provider details, coverage data, and prediction confidence scores.

#### Assistant

Assistants power inbound voice calls, configured [here](https://app.notablehealth.com/staff/app#/assistants). Extract an assistant from Notable's database using an identifier.
`;

  return (
    <DocumentationWithExternalLink
      blockType={UiBlockType.GetNotableObject}
      documentationMarkdown={documentationMarkdown}
    />
  );
}
